import { invoke } from '@shared/easyfy.decorators';

@invoke
export default class IFrameComponent {
  static Instance: IFrameComponent;

  constructor() {}

  onInit() {
    window.addEventListener('message', IFrameComponent.adjustIframeHeight, false);
  }

  // Listens for messages from any iframe and adjusts the height to accommodate the content, adding 20 pixels for additional spacing
  static adjustIframeHeight(e: MessageEvent) {
    let message = e.data;

    if (!message || typeof message.height !== 'number') {
      return;
    }

    let key = (message.id ?? 'unknown').replace(/#/g, '');
    let selector = `[data-key-1="${key}"]`;
    let iframe = document.querySelector(selector);

    if (!iframe) {
      const allIframes = document.querySelectorAll('iframe');
      iframe = Array.from(allIframes).find((iframe) => iframe.contentWindow === e.source) ?? null;
    }

    if (!(iframe instanceof HTMLElement) || !iframe.style) {
      return;
    }

    iframe.style.height = message.height + 20 + 'px';
  }
}
